export default __webpack_public_path__ + "static/media/futura.5eb75ecc.ttf";